export const projectStart = 2019;
export const projectName = 'PianoSolo.me ';
